import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { LoginSendOtp, LoginVerifyOtp } from "../../api/Login";
import { LoadingDiv, SweetAlertShow } from "../master/Master";

export default function Login() {
  const navigate = useNavigate();
  const hostname = window.location.hostname;
  const [loading, setLoading] = useState(false);
  const [ip, setIp] = useState(null);
  const [location, setLocation] = useState(null);
  const [client, setClient] = useState({});

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [message, setMessage] = useState({
    type: "",
    text: "",
  });

  const getLandingRoute = (userPermissions) => {
    const roleName = userPermissions?.name?.trim()?.toLowerCase() || "";

    if (roleName.startsWith("hostel")) {
      return "/hostel/list";
    }

    return "/";
  };

  useEffect(() => {
    const getIP = async () => {
      try {
        const response = await axios.get("https://api64.ipify.org?format=json");

        if (response.data) {
          setIp(response.data.ip);
        }
      } catch (error) {
        console.error("Failed to get IP:", error);
      }
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation(
            JSON.stringify({
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            }),
          );
        },
        (error) => console.error("Error getting location:", error),
        { enableHighAccuracy: true },
      );
    }

    getIP();
  }, []);

  useEffect(() => {
    const clientData = JSON.parse(localStorage.getItem("client") ?? "{}");

    if (!clientData?.username) {
      window.location.href = "/user/verify";
      return;
    }

    setClient(clientData);

    const userData = JSON.parse(localStorage.getItem("user_data") ?? "{}");

    const staff_access = localStorage.getItem("staff_access");

    const setting = localStorage.getItem("setting");
    const sessions = localStorage.getItem("sessions");

    if (
      userData?.remember_token &&
      // user_permissions &&
      clientData?.username &&
      setting &&
      sessions
    ) {
      try {
        const parsedPermissions = JSON.parse(staff_access);

        const landingRoute = getLandingRoute(parsedPermissions);

        navigate(landingRoute);
      } catch (error) {
        console.error("Invalid user_permissions:", error);
        navigate("/");
      }
    }
  }, [navigate]);

  const sendOtp = async () => {
    if (!/^\d{10}$/.test(mobile)) {
      return setMessage({
        type: "danger",
        text: "Please enter a valid 10 digit mobile number.",
      });
    }

    try {
      setLoading(true);

      const response = await LoginSendOtp({
        mobile,
        ip,
        location,
      });

      if (response?.data?.status) {
        setOtpSent(true);
        setOtp("");

        // SweetAlertShow("success", "Success", response?.data?.message);
        setMessage({
          type: "info",
          text: `OTP sent to ${mobile}`,
        });
      } else {
        // SweetAlertShow("warning", "Warning", response?.data?.message);
        setMessage({
          type: "danger",
          text: response?.data?.message,
        });
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (!otp || otp.length < 4) {
      return setMessage({
        type: "danger",
        text: "Please enter a valid OTP.",
      });
    }

    try {
      setLoading(true);

      const response = await LoginVerifyOtp({
        mobile,
        otp,
        ip,
        location,
      });

      if (response?.data?.status) {
        // const userPermissions = response?.data?.data?.user_permissions;
        const userPermissions = response?.data?.data?.staff_access;

        localStorage.setItem(
          "user_data",
          JSON.stringify(response?.data?.data?.user_data),
        );

        localStorage.setItem(
          "user_permissions",
          JSON.stringify(userPermissions),
        );

        localStorage.setItem(
          "setting",
          JSON.stringify(response?.data?.data?.setting),
        );

        localStorage.setItem(
          "sessions",
          JSON.stringify(response?.data?.data?.sessions),
        );

        localStorage.setItem(
          "app_configs",
          JSON.stringify(response?.data?.data?.app_configs),
        );

        localStorage.setItem(
          "staff_access",
          JSON.stringify(response?.data?.data?.staff_access),
        );

        const landingRoute = getLandingRoute(userPermissions);

        navigate(landingRoute);
      } else {
        // SweetAlertShow("warning", "Warning", response?.data?.message);
        setMessage({
          type: "danger",
          text: response?.data?.message,
        });
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUsername = async () => {
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");

      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });

    if ("caches" in window) {
      const cacheNames = await caches.keys();

      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    if ("indexedDB" in window) {
      const databases = await indexedDB.databases();

      if (databases) {
        await Promise.all(
          databases.map((db) => indexedDB.deleteDatabase(db.name)),
        );
      }
    }

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();

      for (let registration of registrations) {
        await registration.unregister();
      }
    }

    localStorage.clear();

    window.location.href = "/user/verify";
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="position-relative bg-school-img">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner py-6 mx-4">
            <div className="card">
              <div className="card-body p-10">
                <div className="row g-4">
                  <div className="col-sm-9 m-auto text-center ri-30px fw-bold">
                    <img
                      src={
                        hostname.includes("tifa.arjtech.xyz")
                          ? "/files/tifa_logo.png"
                          : "/files/logo.png"
                      }
                      style={{ height: "80px" }}
                      alt=""
                    />
                  </div>

                  <div className="col-12">
                    <p className="m-0 ri-20px">
                      Welcome To School Management AI Software
                    </p>
                  </div>

                  <div className="col-12">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={10}
                        className="form-control"
                        placeholder="Mobile No"
                        value={mobile}
                        onChange={(e) => {
                          setMobile(e.target.value);
                          setMessage({ type: "", text: "" });
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !otpSent) {
                            sendOtp();
                          }
                        }}
                        disabled={otpSent}
                      />
                      <label>Mobile No</label>
                    </div>
                  </div>

                  {otpSent && (
                    <div className="col-12">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter OTP"
                          autoFocus
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                            setMessage({ type: "", text: "" });
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              verifyOtp();
                            }
                          }}
                        />
                        <label>Enter OTP</label>
                      </div>
                    </div>
                  )}

                  {message?.text && (
                    <div className="col-12">
                      <div
                        className={`alert alert-${message.type} py-2 mb-0`}
                        role="alert"
                      >
                        {message.text}
                      </div>
                    </div>
                  )}

                  <div className="col-12">
                    {!otpSent ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={sendOtp}
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send OTP"}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={verifyOtp}
                        disabled={loading}
                      >
                        {loading ? "Verifying..." : "Verify OTP"}
                      </button>
                    )}
                  </div>

                  {otpSent && (
                    <div className="col-12 text-center">
                      <span
                        className="text-primary hover-pointer"
                        onClick={sendOtp}
                      >
                        Resend OTP
                      </span>
                    </div>
                  )}

                  <div className="col-md-12 text-center">
                    <p className="m-0">
                      Username :{" "}
                      <b className="text-primary">{client?.username}</b> |{" "}
                      <span
                        className="text-primary hover-pointer"
                        onClick={handleChangeUsername}
                      >
                        Change Username
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
